import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InvestorListContainerComponent } from '@investor-list/investor-list-container/investor-list-container.component';

@Component({
  selector: 'app-investor-block-dialog',
  templateUrl: './investor-block-dialog.component.html',
  styleUrls: ['./investor-block-dialog.component.scss'],
})
export class InvestorBlockDialogComponent implements OnInit {

  device:any;

  public investor :any;

  isBlock:boolean;
  
  constructor(
    public dialogRef: MatDialogRef<InvestorListContainerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.investor = data.investor;
    this.isBlock = data.isBlock;
    if( data.device){
      this.device = data.device;
    }
  }

  ngOnInit() {}

  public onConfirmation() {
    const response = {'investor': this.investor , 'device': this.device ,  'isBlock': this.isBlock};
    this.dialogRef.close(response);
  }

}
